export default __webpack_public_path__ + "images/models/c34c093147982797393b8cc81a234fc2.usdz";